module.exports = __webpack_public_path__ + "static/media/kostol.5641d77c.jpg";